<script setup lang="ts">
import type { DropdownItem } from "~/components/ui/Dropdown.vue";
import Navbar from "~/components/layout/Navbar.vue";
import UiButton from "~/components/ui/Button.vue";
import LayoutSection from "~/components/layout/Section.vue";
import Footer from "~/components/layout/Footer.vue";
import config from "~/config.json";
import Contact from "~/components/layout/Contact.vue";
import ReviewsGrid from "~/components/layout/ReviewsGrid.vue";

useHead({
  title: "Recenze",
});

const servicesDropdownItems: DropdownItem[] = config["services"].flatMap((service) => {
  return service["services-list"].map((item) => ({
    label: item.title,
    value: item.title
  }));
});
</script>

<template>
  <LayoutSection id="hero" background="/images/hero-background.jpg" parallax>
    <Navbar />

    <div class="content">
      <h1>Recenze našich klientů</h1>
      <p>Přečtěte si recenze a zkušenosti našich spokojených zákazníků s našimi zemními a výkopovými pracemi.</p>

      <div class="buttons">
        <UiButton type="primary" variant="solid" href="#contact" trailing-icon="material-symbols:arrow-right-rounded">Kontaktujte nás</UiButton>
        <UiButton type="secondary" variant="solid" href="/">Domů</UiButton>
      </div>
    </div>

    <img src="/images/hero-illustration.svg" title="Ilustrace" class="illustration" aria-label="Ilustrace" fetchpriority="high" loading="eager" provider="static"  alt="Ilustrace"/>
  </LayoutSection>

  <LayoutSection id="reviews">
    <div class="group">
      <div class="section-head">
        <span>Recenze</span>
        <h2>Recenze a zkušenosti našich zákazníků</h2>
        <p>Podívejte se na recenze od našich spokojených zákazníků, kteří sdílejí své zkušenosti s našimi službami a kvalitou práce.</p>
      </div>

      <UiButton type="primary" variant="solid" href="#contact" trailing-icon="material-symbols:arrow-right-rounded">Napište nám</UiButton>
    </div>

    <ReviewsGrid :max-rows-per-page="3" :pagination="true" />
  </LayoutSection>

  <Contact :services-dropdown-items="servicesDropdownItems" />
  <Footer />
</template>

<style scoped lang="scss">
#hero {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 80px;
  min-height: 550px;
  position: relative;
  z-index: 1;

  .illustration {
    position: absolute;
    width: 20%;
    bottom: 0;
    right: 3%;
    transform: translateY(11%);
    pointer-events: none;
    user-select: none;
  }

  .content {
    display: flex;
    flex-direction: column;
    max-width: 800px;
    gap: 30px;
    z-index: 1;

    h1 {
      font-size: 51px;
      font-weight: 700;
      color: rgb(var(--title-dark-color));
    }

    p {
      font-size: 18px;
      color: rgb(var(--text-dark-color));
    }

    .buttons {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
  }
}

#reviews {
  display: flex;
  flex-direction: column;
  gap: 60px;

  .group {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 30px;

    .section-head {
      flex: 1;
    }
  }
}

@media (max-width: 700px) {
  #hero .illustration {
    display: none;
  }
}
</style>